import $ from 'jquery'
import store_stock from "@/store/mods/stock/produits"
import mod_prestation from "@/store/mods/clinique/prestations.js"

export default {
    name: 'm-medicament',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_medicament: '',
            filtered_medicaments: [],
            selected_prestations: [],

            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            medoc_is_loading: true,
            medoc_is_empty: false,

            liste_medicaments_by_categorie: []
        }
    },

    watch: {
        filter_medicament() {
            this.filterMedicament()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        refresh_state() {
            if (this.selected_slug == 'medicament') {
                this.fetchMedicament()
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        fetchMedicament() {
            this.medoc_is_loading = true
            store_stock.getListeMedicamentsParCategorie().then((liste_medicaments_by_categorie) => {
                this.liste_medicaments_by_categorie = liste_medicaments_by_categorie
                if (this.liste_medicaments_by_categorie.length == 0) {
                    this.medoc_is_empty = true
                } else {
                    this.medoc_is_empty = false
                    this.filtered_medicaments = this.liste_medicaments_by_categorie
                }

                this.medoc_is_loading = false
            })
        },

        hadleUndefinedPrice() {
            this.warningToast("Le prix de ce médicament n'a pas été défini !")
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Médicaments',
                data_type: 'medicament',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: (this.info_patient.sexe == 'Masculin')?'H':'F',
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_medicament.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_medicament.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.$refs.fpro_medicament.click()
                    this.dangerToast('Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_medicament.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterMedicament() {
            this.filtered_medicaments = [];

            if (this.filter_medicament == '') {
                this.filtered_medicaments = this.liste_medicaments_by_categorie
            } else {
                this.liste_medicaments_by_categorie.forEach((categorie_medicament) => {
                    categorie_medicament.medicaments.forEach(medicament => {
                        let cleaned_medicament = this.removeAccents(medicament.medicament)
                        let cleaned_filter = this.removeAccents(this.filter_medicament)
    
                        if (cleaned_medicament.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_medicaments.push(medicament)
                        }
                    });
                });
            }
            
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#catmed-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.liste_medicaments_by_categorie.forEach((categorie_medicament) => {
                if (categorie_medicament.categorie_id == index) {
                    let one_price_is_undefined = false

                    categorie_medicament.medicaments.forEach((_data) => {
                        this.text_grey[_data.medicament_id] = (is_checked)?'text-grey':''

                        const tmp_medicament = {
                            id: _data.medicament_id,
                            nom: _data.medicament,
                            prix: _data.prix
                        }
                        if (is_checked) {
                            if (_data.prix == 0 || _data.prix == '') {
                                one_price_is_undefined = true
                            }

                            this.one_is_checked.push(tmp_medicament)
                        } else {
                            this.one_is_checked = this.one_is_checked.filter(item => item.id != tmp_medicament.id)
                        }
                    })

                    if (one_price_is_undefined) {
                        this.warningToast("Le prix d'un ou plusieurs médicaments (décoché(s) dans la liste) n'a pas été défini !")
                    }
                }
            });
            
            this.all_checked = is_checked
        },
    }
}